import { createApi } from '@reduxjs/toolkit/query/react';

import { TAG_RACE_PREVIEW } from '@config/tags';
import { SCHEDULE_RACE_PREVIEW } from '@config/urls';

import { baseQuery } from './baseQuery';

export type RacePreviewArgs = {
  startDate: string;
  endDate: string;
};

export type RacePreviewResponse = {
  blob: Blob;
  filename: string;
};

export const racePreviewApi = createApi({
  reducerPath: 'racePreviewApi',
  tagTypes: [TAG_RACE_PREVIEW],
  baseQuery,
  refetchOnFocus: false,
  endpoints: builder => ({
    getRacePreview: builder.query<RacePreviewResponse, RacePreviewArgs>({
      query: arg => ({
        url: SCHEDULE_RACE_PREVIEW,
        params: { ...arg },
        responseHandler: async response => {
          const blob = await response.blob();

          if (blob.size === 0) {
            return undefined;
          }

          const contentDisposition = response.headers.get('Content-Disposition');
          const filename =
            contentDisposition?.split('filename=')[1]?.replaceAll(/['"]/g, '') ||
            'race-preview.xlsx';

          return { blob, filename };
        },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useLazyGetRacePreviewQuery } = racePreviewApi;
